import { getReferenceString } from '@medplum/core';
import { Practitioner, PractitionerRole } from '@medplum/fhirtypes';
import { useMemo } from 'react';

/**
 * Maps PractitionerRole references to Practitioner IDs for use with PractitionerMultiSelect.
 */
export function useSelectedPractitionerIds(
  providerRefs: string[],
  practitioners: Practitioner[],
  practitionerRoles: PractitionerRole[]
): string[] {
  return useMemo(() => {
    if (!providerRefs.length) return [];

    return providerRefs
      .map((providerRef) => {
        const role = practitionerRoles.find((r) => getReferenceString(r) === providerRef);
        if (!role?.practitioner?.reference) {
          return null;
        }

        const practitioner = practitioners.find((p) => getReferenceString(p) === role.practitioner!.reference);
        return practitioner?.id ?? null;
      })
      .filter((id): id is string => !!id);
  }, [providerRefs, practitionerRoles, practitioners]);
}
